import React from 'react'
import { List } from './style'

export default ({ list }) => (
    <List>
        {list.map((item, index) =>
            <li key={index}>
                {item}
            </li>
        )}
    </List>
)
